export default {
  home: {
    banner: require("@assets/media/banner.mp4"),
    audio: require("@assets/media/audio.mp4"),
  },
}
